import { Alert, Link, Text } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { fetchJson } from '../../../store/fetch';
import { addTrackEvent } from '../customControls/utils/formAnalytics';

interface IMfaQrCodeFormProps {
    activationToken?: string;
    onOtpSecretChange: (otpSecret: string) => void;
    password?: string;
    userName?: string;
}

export function MfaQrCodeForm(props: IMfaQrCodeFormProps) {
    const [verificationWithoutQr, setVerificationWithoutQr] = useState<boolean>(false);
    const [qrcodeDataUrl, setQrcodeDataUrl] = useState<string>();
    const [otpSecret, setOtpSecret] = useState<string>();
    const [otpError, setOtpError] = useState<boolean>(false);

    useEffect(() => {
        loadMfaQrCode();
    }, []);

    function getSplitOtpAlphanumeric() {
        return otpSecret ? otpSecret.match(/\w{4}/g)?.join(' ') : '';
    }

    async function loadMfaQrCode() {
        try {
            const result = await fetchJson('/api/practitioners/generateMfaQrCode', 'POST', {
                activationToken: props.activationToken,
                userName: props.userName,
                password: props.password,
            });

            if (result.json?.qrcodeDataUrl && result.json?.otpSecret) {
                setQrcodeDataUrl(result.json.qrcodeDataUrl);
                setOtpSecret(result.json.otpSecret);
                props.onOtpSecretChange(result.json.otpSecret);
            }
        } catch {
            setOtpError(true);
        }
    }

    return (
        <>
            <Text>
                Heb je een verificatieapp op je smartphone? Voeg dan je Ksyos-account toe aan je verificatieapp door de
                QR-code te scannen.
            </Text>

            {qrcodeDataUrl && (
                <img
                    alt="qrcode"
                    src={qrcodeDataUrl}
                    style={{ marginInline: 'auto' }}
                />
            )}
            <Text
                size="sm"
                textAlign="center"
            >
                <Link
                    color="minimal"
                    fontWeight="normal"
                    onClick={() => {
                        addTrackEvent('MfaQrCodeForm', 'Link Click', 'Handmatig in de verificatieapp invullen');
                        if (!otpError) {
                            setVerificationWithoutQr(!verificationWithoutQr);
                        }
                    }}
                    variant="button"
                >
                    Handmatig in de verificatieapp invullen
                </Link>
            </Text>
            {verificationWithoutQr && (
                <Alert
                    appearance="info"
                    noMargin={true}
                >
                    Lukt het niet om de QR-code te scannen? Voer deze code in je verificatieapp in:{' '}
                    {getSplitOtpAlphanumeric()}
                </Alert>
            )}
            {otpError && (
                <Alert
                    appearance="warning"
                    noMargin={true}
                >
                    Er is bij ons iets verkeerd gegaan. Probeer het later opnieuw, of laat ons je verder helpen. Bel
                    020-600 00 600 of mail info@ksyos.nl.{' '}
                </Alert>
            )}
        </>
    );
}
